export enum PointTimePeriod {
  Current = 'current',
  Previous = 'previous',
}

export interface DatesRange {
  startDate: string
  endDate: string
}
